import { GroupByMode, SortingMode, TaskGroupBy } from '@griply/types';

export const groupByModeTranslationKeys: Partial<Record<TaskGroupBy, string>> =
  {
    [GroupByMode.None]: 'general.group-by-mode.none',
    [GroupByMode.Goal]: 'general.group-by-mode.goal',
    [GroupByMode.LifeArea]: 'general.group-by-mode.life-area',
    [GroupByMode.Priority]: 'general.group-by-mode.priority',
    [GroupByMode.Type]: 'general.group-by-mode.type',
    [GroupByMode.DayPart]: 'general.group-by-mode.time-of-day',
    [GroupByMode.Deadline]: 'general.group-by-mode.deadline',
    [GroupByMode.DeadlineDeadline]: 'general.group-by-mode.deadline-deadline',
    [GroupByMode.Tag]: 'general.group-by-mode.tag',
    [GroupByMode.Section]: 'general.group-by-mode.section',
  };

export const sortingModeTranslationKeys: Partial<Record<SortingMode, string>> =
  {
    [SortingMode.Custom]: 'general.sorting-mode.custom',
    [SortingMode.DueDate]: 'general.sorting-mode.due-date',
    [SortingMode.Priority]: 'general.sorting-mode.priority',
    [SortingMode.DeadlineDeadline]: 'general.sorting-mode.deadline-deadline',
    [SortingMode.CreatedAt]: 'general.sorting-mode.created-at',
    [SortingMode.Name]: 'general.sorting-mode.name',
  };
